import { Component, inject, type OnDestroy, type OnInit } from '@angular/core';
import { type NavigationExtras, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import type { DeepReadonly } from '../../../server/util-type';
import { AuthUserService, type UserOrgObj } from '../auth-user.service';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss'],
  standalone: false,
})
export class AccountComponent implements OnInit, OnDestroy {
  private authUserService = inject(AuthUserService);
  private router = inject(Router);

  loggedIn: DeepReadonly<UserOrgObj> | undefined;
  userNotFound = false;

  accounts:
    | {
        accountId: string;
        email: string;
        orgs: { _id: string; name: string; userId?: string }[];
      }[]
    | undefined;

  subscriptions = new Subscription();

  ngOnInit(): void {
    const userOrgObjSubscription = this.authUserService.userOrgObj.subscribe(
      (userOrgObj) => {
        if (!userOrgObj) return (this.userNotFound = true);
        this.loggedIn = userOrgObj;
      }
    );
    this.subscriptions.add(userOrgObjSubscription);

    const allAccountsSubscription = this.authUserService.allAccounts.subscribe(
      (accounts) => {
        this.accounts = accounts?.map(({ accountId, email, orgs }) => ({
          accountId,
          email,
          orgs: orgs.map(({ _id, name, users }) => ({
            _id,
            name,
            userId: users.find((u) => u.accountId === accountId)?._id,
          })),
        }));
      }
    );
    this.subscriptions.add(allAccountsSubscription);
  }

  selectUser(userId: string | undefined) {
    if (userId) this.authUserService.selectUser(userId);
  }

  selectAccount(accountId: string | undefined) {
    if (accountId) this.authUserService.selectAccount(accountId);
  }

  logInToAnotherAccount() {
    const navigationExtras: NavigationExtras = { queryParams: { add: 1 } };
    this.router.navigate(['/login'], navigationExtras);
  }

  logOut(accountId?: string) {
    this.authUserService.logOut({ accountId });
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
